import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MeetingWaitlist, ReservationItemType, VirtualBookings } from '../../../../models/meetings.model';
import { DataContextService } from '../../../../services/datacontext.service';
import { GlobalSearchService } from './global-search.service';
import * as moment from 'moment';
import { Detail, WaitlistItem } from '../../../../models/bookings.model';
import { debounce } from 'rxjs/operators';
import { interval } from 'rxjs';
import { RoutesConfig } from '../../../../configs/routes.config';
import { MeetingsRoutes } from '../../../../pages/meetings/models/routes';
import { ReferenceType } from '../../../../models/common.enums';
import { BookingRoutes, BookingTabsRoute } from '../../../../pages/bookings/models/routes';
import { ActiveSubTab } from '../../../../pages/bookings/all-bookings/components/booking-details/services/booking-details.service';
import { ReservationsService } from '../../../../services/APIs/reservations/reservations.service';

@Component({
  selector: 'app-global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.less']
})
export class GlobalSearchComponent implements OnInit {
  showNoResults: boolean = true;
  showSpinner: boolean = false;
  search: FormControl = new FormControl(null);
  bookings: GlobalSearchItem[] = [];
  meetingWaitList: GlobalSearchItem[] = [];
  virtualBookings: GlobalSearchItem[] = [];
  waitlists: GlobalSearchItem[] = [];
  RESERVATION_ITEM_TYPES = ReservationItemType;
  constructor(private dataContextService: DataContextService,
    private globalSearchService: GlobalSearchService, private cdRef: ChangeDetectorRef,
    private reservationService: ReservationsService ) { }
  tabs: { value: string, label: string, selected?: boolean, counter: number }[] = [
    {
      label: 'Translation.All',
      value: 'all',
      selected: true,
      counter: 0
    },
    {
      label: 'Translation.Meetings_bookings',
      value: 'booking',
      counter: 0
    },
    {
      label: 'Translation.Meeting_request',
      value: 'meetingWaitlist',
      counter: 0
    },
    {
      label: 'Translation.Waitlist',
      value: 'waitlist',
      counter: 0
    }
  ]
  get selectedTab(): string {
    return this.tabs.find(i => i.selected).value;
  }
  get meetingRequestSlice(): number {
    if (this.selectedTab === 'all') {
      if (!this.virtualBookings.length)
        return 10;
      else if (this.virtualBookings.length >= 5)
        return 5;
      else
        return 10 - this.virtualBookings.length;
    }
    else {
      if (!this.virtualBookings.length)
        return 30;
      else if (this.virtualBookings.length >= 15)
        return 15;
      else
        return 30 - this.virtualBookings.length;
    }
  }
  get virtualBookingSlice(): number {
    if (this.selectedTab === 'all') {
      if (!this.meetingWaitList.length)
        return 10;
      else if (this.meetingWaitList.length >= 5)
        return 5;
      else
        return 10 - this.meetingWaitList.length;
    }
    else {
      if (!this.meetingWaitList.length)
        return 30;
      else if (this.meetingWaitList.length >= 15)
        return 15;
      else
        return 30 - this.meetingWaitList.length;
    }
  }
  get limitReached(): boolean {
    switch (this.selectedTab) {
      case this.tabs[0].value:
        return this.tabs[0].counter > this.MAX_RECORDS_COUNT;
      case this.tabs[1].value:
        return this.tabs[1].counter > this.MAX_RECORDS_COUNT;
      case this.tabs[2].value:
        return this.tabs[2].counter > this.MAX_RECORDS_COUNT;
      case this.tabs[3].value:
        return this.tabs[3].counter > this.MAX_RECORDS_COUNT;
    }
  }
  showLoader: boolean = false;
  noResultsFound: boolean = false;
  MAX_RECORDS_COUNT: number = 30;
  ngOnInit(): void {
    this.handleSearch();
  }
  tabChange(value: string) {
    this.tabs = this.tabs.map(i => {
      return {
        ...i,
        selected: i.value === value ? true : false
      }
    })
  }
  private handleSearch() {
    this.search.valueChanges.pipe(
      debounce(_=> interval(300)))
      .subscribe(value => {
        this.close();
        if (value.length >= 5) {
        this.showLoader = true;
        this.globalSearchService.getGlobalSearchData(value).subscribe(res => {
          this.showLoader = false;
          this.bookings = this.mapBookings(res.bookings);
          //Phase 1 - virtual is not required as dashboard get call will not be made
          this.waitlists = this.mapWaitlists(res.waitlists);
          this.meetingWaitList = this.mapMeetingWaitlists(res.meetingRequests);
          //this.virtualBookings = this.mapVirtualBookings(res.virtualRequests);
          this.tabs = this.tabs.map((i,index) => {
            return {
              ...i,
              counter: index === 0 ? this.bookings.length + this.meetingWaitList.length /* + this.virtualBookings.length */  + this.waitlists.length:
                index === 1 ? this.bookings.length : index === 2 ? this.meetingWaitList.length :this.waitlists.length
                  /* index === 2 ? */  /* + this.virtualBookings.length : 
                  index === 2 ? this.waitlists.length :
                      0 */
            
            }
          })
          this.cdRef.detectChanges();      

          this.noResultsFound = !this.waitlists.length && !this.bookings.length && !this.meetingWaitList.length /* &&  !this.virtualBookings.length */
        })
      }
    })
  }
  clear() {
    this.search.patchValue('');
  }
  private mapBookings(items:Detail[]): GlobalSearchItem[] {
    const bookings = items.map(i => {
      const item: GlobalSearchItem = {
        id: i.spaceBookingId,
        meetingId: i.reservationId,
        name: i.spaceBookingName,
        meetingName: i.reservationName,
        space: i.spaceName,
        buildingName: i.buildingName,
        poc: {
          name: `${i.pointOfContact.firstName} ${i.pointOfContact.lastName}`,
          alias: i.pointOfContact.userName,
          email: i.pointOfContact.email
        },
        owner: {
          name: `${i.owner.firstName} ${i.owner.lastName}`,
          alias: i.owner.userName,
          email: i.owner.email
        },
        itemType: ReservationItemType.SpaceBooking,
        startDate: moment.parseZone(i.startDate).format('l LT'),
        endDate: moment.parseZone(i.endDate).format('l LT'),
        isMidnightSpanning: !moment.parseZone(i.startDate).isSame(moment.parseZone(i.endDate), 'D'),
        statusId: DataContextService.BookingStatus.find(s => s.name === i.statusType) ?
          DataContextService.BookingStatus.find(s => s.name === i.statusType).id : DataContextService.BookingStatus.length,
        spaceType: i.spaceType,
        status : i.statusType,
        reservationStatus: i.reservationStatusType,
      }
      return item;
    });
    let arr: GlobalSearchItem[] = [];
    this.sortOnDate(bookings).forEach(i => {
      i.sort((a, b) => a.statusId < b.statusId ? -1 : a.statusId === b.statusId ? 0 : 1);
      arr = [...arr, ...i];
    });
    return arr;}
  private mapMeetingWaitlists(items: MeetingWaitlist[]): GlobalSearchItem[] {
    let meetingWaitlists = items.map(i => {
      const item: GlobalSearchItem = {
        id: i.id,
        meetingId: i.reservationId,
        name: i.name,
        meetingName: i.reservationName,
        buildingName: i.buildingName,
        owner: {
          name: `${i.owner.firstName} ${i.owner.lastName}`,
          alias: i.owner.userName,
          email: i.owner.email
        },
        poc: {
          name: `${i.pointOfContact.firstName} ${i.pointOfContact.lastName}`,
          alias: i.pointOfContact.userName,
          email: i.pointOfContact.email
        },
        itemType: ReservationItemType.MeetingRequest,
        status: i.meetingWaitListStatusType.name,
        startDate: moment.parseZone(i.startDate).format('l LT'),
        endDate: moment.parseZone(i.endDate).format('l LT'),
        isMidnightSpanning: !moment.parseZone(i.startDate).isSame(moment.parseZone(i.endDate), 'D'),
        statusId: DataContextService.MeetingWaitlistStatus.find(s => s.name === i.meetingWaitListStatusType.name).id,
        reservationStatus: i.reservationStatusType,
      }
      return item;
    });
    let arr: GlobalSearchItem[] = [];
    this.sortOnDate(meetingWaitlists).forEach(i => {
      i.sort((a, b) => a.statusId < b.statusId ? -1 : a.statusId === b.statusId ? 0 : 1);
      arr = [...arr, ...i];
    });
    return arr;}
  private mapVirtualBookings(items: VirtualBookings[]): GlobalSearchItem[] {
    const virtualBookings = items.map(i => {
      const item: GlobalSearchItem = {
        id: i.virtualBookingId,
        virtualBookingNumber: Number(i.virtualBookingReferenceNumber),
        meetingId: i.reservationId,
        name: i.bookingName,
        meetingName: i.reservationName,
        owner: {
          name: `${i.owner.firstName} ${i.owner.lastName}`,
          alias: i.owner.userName,
          email: i.owner.email
        },
        poc: {
          name: `${i.pointOfContact.firstName} ${i.pointOfContact.lastName}`,
          alias: i.pointOfContact.userName,
          email: i.pointOfContact.email
        },
        itemType: ReservationItemType.VirtualBooking,
        status: i.statusType,
        startDate: moment.parseZone(i.startDate).format('l LT'),
        endDate: moment.parseZone(i.endDate).format('l LT'),
        isMidnightSpanning: !moment.parseZone(i.startDate).isSame(moment.parseZone(i.endDate), 'D'),
        statusId: DataContextService.VirtualBookingStatus.find(s => s.name === i.statusType).id,
        reservationStatus: i.reservationStatusType,
      }
      return item;
    });
    let arr: GlobalSearchItem[] = [];
    this.sortOnDate(virtualBookings).forEach(i => {
      i.sort((a, b) => a.statusId < b.statusId ? -1 : a.statusId === b.statusId ? 0 : 1);
      arr = [...arr, ...i];
    });
    return arr;
  }
  private mapWaitlists(items: WaitlistItem[]): GlobalSearchItem[] {
    const waitlists = items.map(i => {
      const item: GlobalSearchItem = {
        owner: {
          name: `${i.owner.firstName} ${i.owner.lastName}`,
          alias: i.owner.userName,
          email: i.owner.email
        },
        status: i.waitListStatusTypes,
        buildingName: i.buildingName,
        startDate: moment.parseZone(i.startDate).format('l LT'),
        endDate: moment.parseZone(i.endDate).format('l LT'),
        isMidnightSpanning: !moment.parseZone(i.startDate).isSame(moment.parseZone(i.endDate), 'D'),
        id: i.id,
        statusId: DataContextService.WaitlistStatus.find(s => s.name === i.waitListStatusTypes).id
      }
      return item;
    });
    let arr: GlobalSearchItem[] = [];
    this.sortOnDate(waitlists).forEach(i => {
      i.sort((a, b) => a.statusId < b.statusId ? -1 : a.statusId === b.statusId ? 0 : 1);
      arr = [...arr, ...i];
    });
    return arr;
  }
  private filterGlobalSearchItem(item: GlobalSearchItem): boolean {
    let regex = new RegExp(this.search.value.toLowerCase());
    if (regex.test(item.owner.name?.toLowerCase()) ||
      regex.test(item.owner.alias?.toLowerCase()) ||
      regex.test(item.owner.email?.toLowerCase()) ||
      regex.test(item.space?.toLowerCase()) ||
      (regex.test(item.id.toString().toLowerCase()) && item.itemType !== this.RESERVATION_ITEM_TYPES.VirtualBooking) ||
      regex.test(item.name?.toLowerCase()) ||
      regex.test(item.meetingId?.toString().toLowerCase()) ||
      regex.test(item.meetingName?.toLowerCase()) ||
      regex.test(item.poc.name?.toLowerCase()) ||
      regex.test(item.poc.alias?.toLowerCase()) ||
      regex.test(item.poc.email?.toLowerCase()))
      return true;
    else
      return false;
  }
  private sortOnDate(res: Array<GlobalSearchItem>): Array<GlobalSearchItem[]> {
    const currentDate = moment();
    const pastArr: GlobalSearchItem[] = res.filter(i => moment(i.startDate).isBefore(currentDate));
    const futureArr: GlobalSearchItem[] = res.filter(i => !pastArr.find(d => d.id === i.id)).sort((a, b) => moment(a.startDate).isBefore(moment(b.startDate)) ? -1 : 1);
    return [futureArr, pastArr];
  }
  close() {
    this.bookings = [];
    this.meetingWaitList = [];
    this.virtualBookings = [];
    this.waitlists = [];
    this.noResultsFound = false;
  }
  navigatToMeeting(item: GlobalSearchItem) {
    let url: string = '';
    const id = `${item.meetingId}_${new Date().getTime()}`;
    this.reservationService.getReservation(item.meetingId).subscribe((res) => {
      const isMeetingReservation = res.type === 'Meeting';
      if (isMeetingReservation)
        url = `/${RoutesConfig.pages.meetings}/${MeetingsRoutes.dashboard}/${MeetingsRoutes.tab}/${id}/${MeetingsRoutes.details}`;
      else
        url = `/${RoutesConfig.pages.bookings}/allBookings/details/${item.id}`;
      const newWin = window.open(url, '_blank');
      const tab: ActiveSubTab = {
        bookingId: item.id.toString(),
        tab: BookingTabsRoute.Overview,
        data: null
      };
      newWin.name = JSON.stringify(tab);
    })
  }
  navigateToDetails(item: GlobalSearchItem) {
    let url: string = '';
    if (item.itemType === this.RESERVATION_ITEM_TYPES.SpaceBooking) {
      url = `/${RoutesConfig.pages.bookings}/allBookings/details/${item.id}`;
    }
    else if (item.itemType === this.RESERVATION_ITEM_TYPES.VirtualBooking) {
      url = `/${RoutesConfig.pages.meetings}/${MeetingsRoutes.requests}/${MeetingsRoutes.tab}/${ReferenceType[ReferenceType.VirtualBooking]}/${item.id}`;
    }
    else {
      url = `/${RoutesConfig.pages.meetings}/${MeetingsRoutes.requests}/${MeetingsRoutes.tab}/${ReferenceType[ReferenceType.MeetingWaitList]}/${item.id}`;
    }
    window.open(url, '_blank');
  }
  navigateWaitlist(item: GlobalSearchItem) {
    window.open(`/${BookingRoutes.bookings}/${BookingRoutes.waitlist}/details/${item.id}`, '_blank');
  }
}
interface GlobalSearchItem {
  id?: number | string;
  meetingId?: number;
  name?: string;
  meetingName?: string;
  space?: string;
  buildingName?: string;
  poc?: GlobalSearchUserItem;
  owner?: GlobalSearchUserItem;
  itemType?: ReservationItemType;
  status?: string;
  startDate?: string;
  endDate?: string;
  isMidnightSpanning?: boolean;
  virtualBookingNumber?: number;
  statusId?: number;
  spaceType?: string;
  reservationStatus?:string;
}
interface GlobalSearchUserItem {
  name?: string;
  alias?: string;
  email?: string;
}
